module.exports = __webpack_public_path__ + "img/Diamond-Services-ID.b160ec2f.png";